var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.page.redirect)?_c('router-link',{attrs:{"to":`/page/${this.page.id}`,"target":_vm.pageTarget}},[_vm._v(" "+_vm._s(_vm.page.title)+" ")]):_c('a',{attrs:{"href":_vm.page.url,"target":_vm.pageTarget}},[_vm._v(_vm._s(_vm.page.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }